import React from "react";

import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";

export const AddClusterIcon = React.forwardRef<HTMLElement, MuiIconExternalProps>(
    (props: MuiIconExternalProps, ref) => {
        return (
            <MuiIcon {...props}
                     ref={ref}
            >  {'\uE2C7'}</MuiIcon>
        );
    }
)

